import Layout from '@/layout';

export default [
  {
    path: '/studio',
    name: 'Studio',
    redirect: '/studio/introduceMember',
    component: Layout,
    meta: {
      title: '工作室',
      icon: 'icon-studio',
      activePath: 'introduceMember',
    },
    children: [
      {
        path: 'introduceMember',
        name: 'StudioIntroduceMember',
        component: () => import('@/views/studio/introduceMember.vue'),
        meta: {
          title: '工作室概况',
          activePath: 'introduceMember',
        },
      },
    ],
  },
];
